import { transport } from 'config/transport';

export function callApiCreateBHYT(congDoanId, nunId, body) {
    return transport.post(`/congdoan/${congDoanId}/baohiemyte/${nunId}`, body);
}
